import React from 'react';

import aboutImg from '../../assets/images/about.jpg';

const HomeAbout = () => {
    return (
        <div className='homeAbout'>
            <div className="container">
                <div className="homeAboutMain">
                    <div className="homeAboutThumbnail">
                        <img src={aboutImg} alt="" />
                    </div>
                    <div className="homeAboutDetails">
                        <h2 className='title'>Nursing Success Mentor</h2>
                        <p>Vijitha Anish, an accomplished nursing instructor, specializes in training nurses for licensing exams like NCLEX RN, DHA, HAAD, and Prometric, ensuring academic success and professional growth.</p>
                        <ul>
                            <li>
                                <div className="pointHead">
                                    <div className="dot"></div>
                                    <h4>Student Satisfaction</h4>
                                </div>
                                <div className="pointBody">
                                    <h3>99%</h3>
                                    <h5>Highly praised for teaching and exam preparation.</h5>
                                </div>
                            </li>
                            <li>
                                <div className="pointHead">
                                    <div className="dot"></div>
                                    <h4>Exam Success Rate</h4>
                                </div>
                                <div className="pointBody">
                                    <h3>98%</h3>
                                    <h5>98% success in NCLEX RN, DHA, HAAD, Prometric.</h5>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeAbout;